import { Direction, getGetStalledPlatformMessagesQueryKey, MessageResendSuccessDTO, useResendStalledMessages } from "@bvhi/backend-api";
import { Card, CardContent, CardHeader, LoadingButton } from "@bvhi/ui-base";
import { ReplyIcon } from "@bvhi/ui-icons";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "../../../../../hooks/use-toast";
import { toNarrowedTypeOrNull } from "../../../../../utils/ts";
import { useQueryClient } from "@tanstack/react-query";

export const MessagesResendMessagesCard = () => {
  const { t } = useTranslation(["settings"]);
  const queryClient = useQueryClient();

  const { mutate: requestToRescheduleStalledMessages, isPending: requestIsPending } = useResendStalledMessages();
  const { pushCustomErrorToast, pushCreateSuccessToast } = useToast();

  const request = useCallback(() => {
    requestToRescheduleStalledMessages(
      (() => {
        // this is just to please TypeScript
      })(),
      {
        onSuccess: (data) => {
          const messageResendSuccessDTO = toNarrowedTypeOrNull<MessageResendSuccessDTO>(data?.data, "totalRescheduled");
          if (messageResendSuccessDTO) {
            pushCreateSuccessToast(t("settings:resend.message.toast.success", { total: messageResendSuccessDTO.totalRescheduled }));
          }
        },
        onError: () => pushCustomErrorToast(t("settings:resend.message.toast.error")),
        onSettled: () => {
          void queryClient.invalidateQueries({ queryKey: getGetStalledPlatformMessagesQueryKey({ direction: Direction.INCOMING }) });
          void queryClient.invalidateQueries({ queryKey: getGetStalledPlatformMessagesQueryKey({ direction: Direction.OUTGOING }) });
        },
      }
    );
  }, [pushCustomErrorToast, queryClient, pushCreateSuccessToast, requestToRescheduleStalledMessages, t]);

  return (
    <>
      <Card>
        <CardHeader subheader={t("settings:resend.message.card.subheader")} title={t("settings:resend.message.card.title")} />
        <CardContent>
          <LoadingButton loading={requestIsPending} onClick={request} startIcon={<ReplyIcon />}>
            {t("settings:resend.message.card.button.label")}
          </LoadingButton>
        </CardContent>
      </Card>
    </>
  );
};
